import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=ca274c84&scoped=true&"
import script from "./AboutMe.vue?vue&type=script&lang=ts&"
export * from "./AboutMe.vue?vue&type=script&lang=ts&"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=ca274c84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca274c84",
  null
  
)

export default component.exports